module.exports = __webpack_public_path__ + "media/about/max-volsky-and-max-schmidt-77bab107.png";